import { useEffect } from 'react';
import config from './config';

/**
 * ThemeProvider component
 * Applies CSS variables from config to the document root
 * This enables easy theming by just changing config.js
 */
function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    const { colors } = config;

    // Apply all color variables to :root
    root.style.setProperty('--color-primary', colors.primary);
    root.style.setProperty('--color-primary-hover', colors.primaryHover);
    root.style.setProperty('--color-primary-light', colors.primaryLight);
    
    root.style.setProperty('--color-secondary', colors.secondary);
    root.style.setProperty('--color-secondary-hover', colors.secondaryHover);
    
    root.style.setProperty('--color-success', colors.success);
    root.style.setProperty('--color-success-light', colors.successLight);
    root.style.setProperty('--color-success-border', colors.successBorder);
    
    root.style.setProperty('--color-error', colors.error);
    root.style.setProperty('--color-error-light', colors.errorLight);
    root.style.setProperty('--color-error-border', colors.errorBorder);
    
    root.style.setProperty('--color-warning', colors.warning);
    root.style.setProperty('--color-warning-light', colors.warningLight);
    root.style.setProperty('--color-warning-border', colors.warningBorder);
    root.style.setProperty('--color-warning-text', colors.warningText);
    
    root.style.setProperty('--color-background', colors.background);
    root.style.setProperty('--color-background-card', colors.backgroundCard);
    root.style.setProperty('--color-background-dark', colors.backgroundDark);
    
    root.style.setProperty('--color-text-primary', colors.textPrimary);
    root.style.setProperty('--color-text-secondary', colors.textSecondary);
    root.style.setProperty('--color-text-muted', colors.textMuted);
    root.style.setProperty('--color-text-light', colors.textLight);
    
    root.style.setProperty('--color-border', colors.border);
    root.style.setProperty('--color-border-light', colors.borderLight);
    
    root.style.setProperty('--color-accent-1', colors.accent1);
    root.style.setProperty('--color-accent-2', colors.accent2);

    // Navbar and Footer colors
    root.style.setProperty('--color-navbar-bg', colors.navbarBackground);
    root.style.setProperty('--color-navbar-text', colors.navbarText);
    root.style.setProperty('--color-footer-bg', colors.footerBackground);
    root.style.setProperty('--color-footer-text', colors.footerText);

    // Button colors
    root.style.setProperty('--color-button-primary', colors.buttonPrimary);
    root.style.setProperty('--color-button-primary-hover', colors.buttonPrimaryHover);
    root.style.setProperty('--color-button-text', colors.buttonText);

    // Logo styling
    root.style.setProperty('--color-logo-background', colors.logoBackground || 'transparent');
    root.style.setProperty('--color-logo-padding', colors.logoPadding || '0');
    root.style.setProperty('--color-logo-border-radius', colors.logoBorderRadius || '0');

    // Update favicon if specified
    if (config.brand.favicon) {
      const existingFavicon = document.querySelector("link[rel*='icon']");
      if (existingFavicon) {
        existingFavicon.href = config.brand.favicon;
      } else {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = config.brand.favicon;
        document.head.appendChild(link);
      }
    }

    // Update page title
    document.title = `${config.brand.name} - ${config.text.appTitle}`;
  }, []);

  return children;
}

export default ThemeProvider;
